export function reduceArrayById(array: Array<any>, identifier: string = 'id') {
  return array
    ? array.reduce((prev, item) => {
        return { ...prev, [item[identifier]]: item };
      }, {})
    : {};
}
